'use client';

import { ErrorPage } from '@/lib/page-modules/errorPage';

export default function Error({ error, reset }) {
    return <ErrorPage lang="ru" error={error} reset={reset} />;
}
